import ImageContextBase from "./imageContextBase";
import { EyeTypes } from "../config/config";
import store from "../store";
import HvfView from "./hvfView";
import {getSameDateExams, getExamsWithUniqueDate} from  "../helpers/utils";

export default class HvfContext extends ImageContextBase {
  constructor(exam, image){
    super(exam, "hvfBrowserBody", "HVF VIEW");
    this.allHvFExams = store.getters.visualFieldExams;
    this.exams = [];
    this.view = new HvfView(exam, image);
    this.eyeFilter = EyeTypes.OU;
  }

  startupTask() {
    let sameDateExams = getSameDateExams(this.allHvFExams, this.exam.dateDisplay); 
    let exSrNos = sameDateExams.map(e => e.exSrNo);
    this.exams = getExamsWithUniqueDate(this.allHvFExams);
    
    store.dispatch("loadExamImageMetadata", {exSrNos}).then(() => {
      this.view.setupView(sameDateExams)
      this.view.loadImages()
    });
  }

  clearContext() {
    this.exams = null;
    this.view.clear();
    this.view = null;
  }

  selectHVFExam(exam) {
    this.exam = exam;
    this.exSrNo = exam.exSrNo;
    this.view.exam = exam;
    
    let sameDateExams = getSameDateExams(this.allHvFExams, this.exam.dateDisplay); 
    let exSrNos = sameDateExams.map(e => e.exSrNo);
    store.dispatch("loadExamImageMetadata", {exSrNos}).then(() => {
      this.view.image = null;
      this.view.setupView(sameDateExams)
      this.view.loadImages()
    });
    
  }

  selectHVFEye(eye) {
    this.eyeFilter = eye;
  }

  previousHVFImage() {
    this.view.prev();
  }

  nextHVFImage() {
    this.view.next();
  }
}